export const fr = {
    consent: {
        titulo: "Consentement aux cookies",
        texto: "Nous utilisons des cookies pour mesurer les visites et améliorer la communication de l'événement. La mesure marketing n'est activée qu'avec votre consentement.",
        aceitar: "Accepter",
        rejeitar: "Essentiels uniquement",
        saberMais: "En savoir plus",
    },
    nav: {
        experiencia: "Expérience",
        noiteFados: "Nuit de Fado",
        equipa: "Équipe",
        artistas: "Artistes",
        noticias: "Actualités",
        missao: "Mission",
        associacao: "L'Association",
        vantagens: "Avantages Membres",
        contacto: "Contact",
        reservar: "Réserver",
        local: "Accès",
    },
    hero: {
        headlineTop: "UNE SOIRÉE\nDÉDIÉE AU",
        headlineAdj: "PORTUGAIS",
        headlineItalico: "Une soirée portugaise.\nÀ table.\nEn direct.",
        quando: "Quand",
        data: "14 novembre 2026",
        hora: "à partir de 17h00",
        onde: "Où",
        local: "Centro Papa Giovanni",
        morada: "Hübelistrasse 55, Emmenbrücke",
        comprar: "Acheter des Billets",
        urgencia: "Événement exclusif · Places limitées",
        saibaMais: "En savoir plus",
        countdown: {
            label: "Le tarif Early Bird se termine dans",
            dias: "jours",
            horas: "heures",
            min: "min",
            seg: "sec",
        },
    },
    pillars: [
        { id: "fado-ao-vivo", title: "Fado en Direct", text: "L'émotion du Fado, patrimoine immatériel du Portugal." },
        { id: "gastronomia", title: "Gastronomie Portugaise", text: "Saveurs traditionnelles dans un dîner préparé avec excellence." },
        { id: "vinhos", title: "Vins Portugais", text: "Une sélection de vins des meilleures régions du Portugal." },
        { id: "cultura", title: "Culture et Tradition", text: "Une célébration de notre identité, de notre histoire et de notre hospitalité." },
        { id: "ambiente", title: "Ambiance Exclusive", text: "Un espace intime pour une expérience inoubliable." },
    ],
    watermark: "Exemple Visuel",
    influencer: {
        label: "Influenceur Officiel",
        nome: "Nelson Jackson",
        titulo: "La voix qui porte Fados à Mesa auprès de la communauté",
        texto: "Nelson Jackson est l'influenceur officiel de Fados à Mesa. Le drapeau sur les épaules et son énergie habituelle, il nous accompagnera dans le compte à rebours vers la soirée du 14 novembre — coulisses, nouveautés et surprises sur les réseaux sociaux.",
        legenda: "Le message de Nelson Jackson à la communauté portugaise",
        play: "Voir la vidéo",
    },
    convidadoHonra: {
        label: "Invité d'Honneur",
        confirmado: "Participation confirmée",
        bemVindo: "Soyez le bienvenu, Excellence !",
        excelencia: "Son Excellence",
        nome: "Dr. Gonçalo Motta",
        cargo: "Consul Général du Portugal à Zurich",
        citacao: "La culture nous rapproche. Le Portugal vit en chacun de nous.",
        texto: "C'est avec un grand honneur que nous accueillons Son Excellence le Dr. Gonçalo Motta, Consul Général du Portugal à Zurich, comme invité d'honneur de Fados à Mesa. La présence de la représentation diplomatique du Portugal est une reconnaissance de la valeur de la culture portugaise et de l'importance de garder nos traditions vivantes, en unissant la communauté autour de la musique, de la gastronomie et de notre identité.",
        sobreTitulo: "À propos du Dr. Gonçalo Motta",
        sobre: "Le Dr. Gonçalo Motta est l'actuel Consul Général du Portugal à Zurich, représentant le Ministère des Affaires étrangères du Portugal. Formé à l'Universidade Lusíada de Lisbonne et fort d'une vaste expérience diplomatique, il se consacre au renforcement des relations entre le Portugal et la Suisse, au soutien des communautés portugaises et à la promotion de la culture et de l'image du Portugal à l'étranger.",
        verCartaz: "Voir l'affiche officielle",
    },
    patrocinadores: {
        titulo: "SPONSORS OFFICIELS",
        maisA: "Et d'autres",
        maisB: "Sponsors",
        agradecimentos: {
            famosa: "Notre profonde gratitude à la Pastelaria Famosa, Sponsor Exclusif, pour sa confiance et la douceur avec laquelle elle accompagne cette soirée depuis le premier jour.",
            srVinho: "Merci au Sr. Vinho, restaurant typique qui accueille nos membres avec 10% de réduction et un digestif offert.",
            cr7Helder: "Nos sincères remerciements à CR7 Helder, pour sa confiance dans le Fado et pour nous conduire, avec élégance, jusqu'à cette soirée.",
            saboresPortugal: "Nos sincères remerciements à Sabores de Portugal, pour apporter à table le meilleur de notre gastronomie et donner à cette soirée un vrai goût de Portugal.",
            wildenMann: "Merci à l'Hôtel Wilden Mann, cinq siècles d'hospitalité lucernoise aux côtés du Fado.",
            barniPost: "Merci au Barni-Post, qui porte le Fado dans chaque foyer de Suisse centrale.",
            superBock: "Merci au Super Bock Group, qui apporte à table la plus portugaise des bières.",
            clubPortugues: "Merci au Club Português Luzern, maison de notre communauté depuis tant d'années.",
            casaBenfica: "Merci à la Casa Benfica Zurique, pour la passion qui unit les Portugais de toute la Suisse.",
            immoHaus: "Merci à ImmoHaus Portugal, qui aide tant de familles à trouver une maison — et nous ouvre la sienne.",
        },
    },
    artistas: { titulo: "NOS ARTISTES" },
    parceiros: { titulo: "PARTENAIRES INSTITUTIONNELS" },
    localizacao: {
        saberMais: "En savoir plus",
        label: "Où se déroule l'événement",
        titulo: "COMMENT VENIR",
        intro: "L'événement a lieu à Emmenbrücke, accessible en transports publics, en voiture ou à vélo. Ci-dessous, les informations pratiques d'accès.",
        moradaLabel: "Adresse",
        moradaValor: "Centro Papa Giovanni, Hübelistrasse 55, 6020 Emmenbrücke, Suisse",
        gpsLabel: "Coordonnées GPS",
        gpsValor: "47.0706° N, 8.2849° E",
        acessosTitulo: "Accès",
        transportesTitulo: "Transports Publics",
        transportes: "Gare d'Emmenbrücke Gersag à environ 10 minutes à pied (trains régionaux et bus 41, 42, 43 et 44). Depuis Lucerne, ligne VBL 2 ; bus de nuit N2 au retour.",
        carroTitulo: "Voiture",
        carro: "À 5 minutes de l'autoroute A2 (sortie Emmen Nord).",
        bicicletaTitulo: "Vélo",
        bicicleta: "Parking à vélos disponible sur place.",
        estacionamentoTitulo: "Parking Gratuit",
        estacionamento: "Parking Häger gratuit juste en face — uniquement les places signalées « Häger », selon disponibilité. Autres parkings à proximité, gratuits et payants.",
        regrasTitulo: "Règles du Centro Papa Giovanni",
        regras: [
            "L'entrée et la présence d'animaux de compagnie sont interdites.",
            "Il est interdit de fumer dans toute la zone intérieure du bâtiment.",
        ],
    },
    cta: {
        comprar: "Acheter des Billets",
        urgencia: "Événement exclusif · Places limitées",
        titulo: "RÉSERVEZ VOTRE PLACE.",
        subtitulo: "Une soirée. Une table. Un Fado.",
    },
    culturaNoticias: {
        noticias: "DERNIÈRES NOUVELLES",
        nota: "Actualités d'exemple — les nouveautés sur l'événement apparaîtront ici.",
        news: [
            { title: "Fados à Mesa lance sa première édition le 14 novembre 2026", date: "15 MAI 2025" },
            { title: "Découvrez les artistes qui donnent vie au Fado sur scène", date: "10 MAI 2025" },
            { title: "Saveurs du Portugal : le dîner qui célèbre notre tradition", date: "05 MAI 2025" },
        ],
    },
    footer: {
        frase: "Une soirée Portugaise, sans aucun doute.",
        copyright: "© 2026 Fados à Mesa – Tous droits réservés.",
        sede: "Association Fados à Mesa · UID CHE-306.330.271 · Gerliswilstrasse 46, 6020 Emmenbrücke, Suisse",
        privacy: "Politique de Confidentialité",
        terms: "Conditions Générales",
        colunas: [
            {
                title: "Nuit de Fado",
                links: [
                    { label: "Menu de la Soirée", to: "/experiencia?tab=menu" },
                    { label: "Culture et Tradition", to: "/experiencia?tab=cultura" },
                    { label: "Gastronomie et Vins", to: "/experiencia?tab=gastro" },
                    { label: "Bar", to: "/experiencia?tab=bar" },
                    { label: "Équipe", to: "/equipa", ate1aEdicao: true },
                ],
            },
            {
                title: "Artistes",
                links: [
                    { label: "Artistes", to: "/#artistas" },
                    { label: "Actualités", to: "/noticias" },
                ],
            },
            {
                title: "L'Association",
                links: [
                    { label: "Mission", to: "/missao" },
                    { label: "Avantages Membres", to: "/socios/vantagens" },
                    { label: "Devenir Membre", to: "/associacao#adesao" },
                    { label: "Sponsors", to: "/patrocinadores" },
                ],
            },
            {
                title: "Billets",
                links: [
                    { label: "Acheter des Billets", to: "/bilhetes" },
                    { label: "Confirmer sa Présence", to: "/confirmar" },
                ],
            },
            {
                title: "Contact",
                links: [
                    { label: "Nous Contacter", to: "/contacto" },
                    { label: "Accès", to: "/local" },
                    { label: "Centre de Ressources", to: "/recursos" },
                ],
            },
        ],
    },
    subpage: { voltar: "Retour" },
    audio: { tocar: "Écouter la musique", pausar: "Mettre la musique en pause" },
    bc: {
        home: "Accueil",
        experiencia: "Expérience",
        equipa: "Équipe",
        artistas: "Artistes",
        noticias: "Actualités",
        missao: "Mission",
        contacto: "Contact",
        local: "Accès",
        confirmar: "Confirmation",
        bilhetes: "Billetterie",
        privacidade: "Politique de Confidentialité",
        termos: "Conditions Générales",
        recursos: "Centre de Ressources",
        patrocinadores: "Sponsors",
    },
    seo: {
        keywords: "Fado, Fados à Mesa, culture portugaise, gastronomie portugaise, vins portugais, événement portugais Suisse, Fado Lucerne, Emmenbrücke, dîner-spectacle, Ticket Corner",
        home: { title: "Fados à Mesa — Fado, Gastronomie et Vins portugais en Suisse", desc: "Dîner-spectacle avec Fado en direct, gastronomie et vins portugais. 14 novembre 2026, Centro Papa Giovanni, Emmenbrücke. Réservez votre billet." },
        experiencia: { title: "L'Expérience — Menu, Line-up et Étiquette du Fado | Fados à Mesa", desc: "Découvrez le menu officiel, le line-up de la soirée et l'étiquette du Fado : une soirée portugaise servie à table, entre plats traditionnels et fado en direct." },
        equipa: { title: "Notre Équipe — Production et Staff | Fados à Mesa", desc: "Découvrez l'équipe qui fait vivre la soirée : production exécutive et artistique, cuisine et salle de la 1ère édition de Fados à Mesa." },
        missao: { title: "La Mission — Culture Portugaise en Suisse | Fados à Mesa", desc: "Apporter la culture portugaise en Suisse — une soirée, une table et une guitare à la fois. Culture, table et rencontre : les valeurs de Fados à Mesa." },
        contacto: { title: "Contact — Écrivez-nous | Fados à Mesa", desc: "Contacts de l'événement Fados à Mesa : réservations de groupes, partenariats et parrainages, presse et questions sur la 1ère édition." },
        local: { title: "Accès — Centro Papa Giovanni, Emmenbrücke | Fados à Mesa", desc: "Comment rejoindre le Centro Papa Giovanni (Hübelistrasse 55, Emmenbrücke) : transports publics, voiture, Uber et vélo. Parking gratuit." },
        noticias: { title: "Actualités — Fado, Culture Portugaise et Nouveautés | Fados à Mesa", desc: "Annonces officielles de Fados à Mesa et articles sélectionnés sur nos artistes : Rafael Pacheco, Ginestal Martins, Cátia Garcia, Daniel Pinto Coelho et Madalena Gil." },
        confirmar: { title: "Confirmer ma Présence — Choisir le Plat | Fados à Mesa", desc: "Confirmez votre présence à Fados à Mesa et choisissez votre plat principal (poisson ou viande) avant le 1er novembre 2026." },
        bilhetes: { title: "Billetterie Officielle — Acheter des Billets | Fados à Mesa", desc: "Achetez votre billet pour Fados à Mesa à la billetterie officielle (Eventim / Ticket Corner). Événement exclusif, places limitées. 14.11.2026, Emmenbrücke." },
        privacidade: { title: "Politique de Confidentialité | Fados à Mesa", desc: "Politique de confidentialité de Fados à Mesa — traitement des données personnelles conformément à la loi suisse (nLPD)." },
        associacao: { title: "L'Association | Fados à Mesa", desc: "L'Association Fados à Mesa : qui sommes-nous, données institutionnelles, direction, partenaires, cotisations, demande d'adhésion et statuts." },
        termos: { title: "Conditions Générales | Fados à Mesa", desc: "Termes et conditions du site et de l'événement Fados à Mesa." },
        recursos: { title: "Centre de Ressources — Presse et Partenaires | Fados à Mesa", desc: "Documents officiels de Fados à Mesa pour la presse et les partenaires : project book, press kit, logos et programme de la soirée." },
        patrocinadores: { title: "Sponsors Officiels | Fados à Mesa", desc: "Les partenaires officiels de Fados à Mesa — une soirée portugaise en Suisse." },
    },
    assoc: {
        titulo: "L'ASSOCIATION",
        intro: "Une association à but non lucratif, politiquement neutre et confessionnellement indépendante, constituée à Emmen le 25 septembre 2026.",
        subnav: { quemSomos: "Qui sommes-nous", dados: "Données", direcao: "Direction", parceiros: "Partenaires", quotas: "Cotisations", adesao: "Adhésion", estatutos: "Statuts" },
        quemSomos: {
            titulo: "QUI SOMMES-NOUS",
            p1: "L'Association Fados à Mesa est une association à but non lucratif, politiquement neutre et confessionnellement indépendante, dont le siège est à Emmen, canton de Lucerne. Elle a pour but de promouvoir, préserver et diffuser la culture portugaise et lusophone en Suisse, en particulier le fado, la musique, la gastronomie, la langue et les traditions portugaises.",
            p2: "Pour cela, nous organisons des événements culturels, musicaux, gastronomiques, éducatifs et sociaux, notre projet principal étant l'événement «Fados à Mesa». Nous promouvons les échanges culturels entre la communauté lusophone et la population suisse, soutenons des artistes et des créateurs d'expression portugaise et coopérons avec des communes, des cantons, des fondations, des entreprises, des institutions culturelles et d'autres associations.",
            p3: "Nos activités sont ouvertes au public en général. L'association ne poursuit pas de but lucratif: d'éventuels excédents sont intégralement affectés aux buts statutaires et ne sont jamais distribués aux membres.",
        },
        dados: {
            titulo: "DONNÉES INSTITUTIONNELLES",
            denominacao: "Désignation", formaJuridica: "Forme juridique", sede: "Siège", morada: "Adresse",
            constituicao: "Date de constitution", duracao: "Durée", uid: "Numéro UID", conta: "Compte bancaire",
            exercicio: "Exercice social", contacto: "Contact",
            denominacaoV: "Associação Fados à Mesa (Verein Fados à Mesa)",
            formaJuridicaV: "Association à but non lucratif, art. 60 et ss. CC",
            sedeV: "Commune d'Emmen, canton de Lucerne, Suisse",
            moradaV: "Gerliswilstrasse 46, 6020 Emmenbrücke",
            constituicaoV: "25.09.2026 (Assemblée de fondation, procès-verbal n° 1)",
            duracaoV: "Durée indéterminée",
            emTratamento: "En cours", aDesignar: "À désigner",
            exercicioV: "Année civile",
        },
        direcao: {
            titulo: "DIRECTION ET MEMBRES FONDATEURS",
            comite: "Comité Exécutif", mandato: "Mandat 2026–2028",
            fundadores: "Membres fondateurs avec des fonctions les jours d'événement",
            nota: "La Présidente, la Vice-Présidente, la Directrice de Logistique et le Directeur Technique sont les quatre membres fondateurs de l'association.",
            paulaAngelinoNota: "Assume également la direction artistique, le marketing, le design et la communication.",
            cristinaNota: "Assume tous les pouvoirs exécutifs en cas d'empêchement de la Présidente.",
            paulaSilvaNota: "Gestion de la logistique et des équipes les jours d'événement.",
            pauloNota: "Coordination technique des événements.",
            cargoPaulaAngelino: "Présidente et Directrice Exécutive",
            cargoCristina: "Vice-Présidente",
            cargoPaulaSilva: "Membre fondatrice et Directrice de Logistique",
            cargoPaulo: "Membre fondateur et Directeur Technique",
        },
        parceiros: {
            titulo: "PARTENAIRES ET SPONSORS",
            intro: "Institutions et partenaires qui se sont joints à nous pour donner une voix à la culture portugaise en Suisse. La culture se construit aussi en partenariat.",
            institucional: "Partenaire institutionnel",
            patrocinadores: "Sponsors",
            parceiroInstitucional: "Partenaire institutionnel",
            celimar: "Partenaire exclusif du conseil et des assurances",
            ptPrint: "Imprimerie Partenaire",
            barniPost: "Media Partner · Édition du 21 octobre 2026",
            tiers: { exclusiva: "Sponsor Exclusif", oficial: "Partenaire Officiel", premium: "Sponsor Premium Officiel", intermediario: "Co-sponsor", apoiante: "Soutien" },
            tiersPlural: { exclusiva: "Sponsor Exclusif", oficial: "Partenaire Officiel", premium: "Sponsors Premium", intermediario: "Co-sponsors", apoiante: "Soutiens" },
        },
        quotas: {
            titulo: "COTISATIONS ET ADHÉSION",
            valor: "Cotisation: CHF 2 par mois (CHF 24 par an).",
            isencao: "Les membres fondateurs et les membres honoraires sont dispensés de cotisation, de manière permanente.",
            comoPagar: "Comment payer la cotisation. Pendant que le compte bancaire de l'association est en cours de désignation, la cotisation peut être payée en espèces, directement auprès de {famosa}. Conservez la preuve de paiement et joignez-la à votre demande d'adhésion.",
            admissao: "Admission. La demande d'adhésion est examinée par le Comité Exécutif, qui décide conformément à l'art. 6 des Statuts.",
            categoriasTitulo: "Catégories de membres (art. 5 des Statuts)",
            fundadores: "Fondateurs — dispensés de cotisation, de manière permanente",
            efetivos: "Effectifs — personnes physiques ou morales admises par le Comité Exécutif",
            honorarios: "Honoraires — services éminents rendus à l'association, dispensés de cotisation",
            apoiantes: "De soutien — soutiennent financièrement l'association; sans droit de vote",
        },
        form: {
            titulo: "DEMANDE D'ADHÉSION",
            nome: "Nom complet", rua: "Rue et numéro", cp: "Code postal", localidade: "Localité", pais: "Pays",
            email: "E-mail", telefone: "Téléphone", telefoneOpc: "facultatif",
            categoria: "Catégorie souhaitée", catEfetivo: "Membre effectif", catApoiante: "Membre de soutien",
            comprovativo: "Preuve de paiement de la cotisation",
            comprovativoNota: "PDF, JPG ou PNG · max. 10 Mo",
            escolherFicheiro: "Choisir un fichier",
            aceiteEstatutos: "J'ai lu et j'accepte les Statuts de l'Association Fados à Mesa.",
            verEstatutos: "voir les Statuts",
            aceiteDados: "J'autorise le traitement de mes données personnelles par l'Association Fados à Mesa, exclusivement pour la gestion de mon adhésion, conformément à la Loi fédérale sur la protection des données (nLPD).",
            verNota: "voir la note de protection des données",
            enviar: "Envoyer la demande", aEnviar: "Envoi en cours...",
            sucesso: "Demande reçue. Votre demande d'adhésion sera examinée par le Comité Exécutif. Vous recevrez la réponse par e-mail.",
            erroObrigatorio: "Champ obligatoire",
            erroEmail: "E-mail invalide",
            erroFicheiroTipo: "PDF, JPG ou PNG uniquement",
            erroFicheiroGrande: "Le fichier dépasse 10 Mo",
            erroGeral: "La demande n'a pas pu être envoyée. Veuillez réessayer.",
        },
        estatutos: { titulo: "STATUTS", indice: "Index", descarregar: "Télécharger les Statuts (PDF)" },
        cartao: {
            titulo: "CARTE DE MEMBRE",
            categoriaEfetivo: "Membre Effectif", categoriaApoiante: "Membre de Soutien",
            numero: "Membre N.º", desde: "Membre depuis", valido: "Carte valide",
            guardar: "Enregistrer l'image", partilhar: "Partager",
            nota: "Présentez cette carte lors des événements de l'Association Fados à Mesa. Enregistrez l'image sur votre téléphone ou ajoutez cette page à votre écran d'accueil.",
            invalidoTitulo: "Carte non valide",
            invalidoTexto: "Cette carte de membre n'est pas valide ou a été révoquée. En cas de doute, contactez-nous via la page Contact.",
            aCarregar: "Vérification de la carte…",
        },
        protecao: {
            titulo: "PROTECTION DES DONNÉES",
            texto: "L'Association Fados à Mesa traite les données personnelles de ses membres et requérants exclusivement pour la gestion des adhésions et des activités de l'association, conformément à la Loi fédérale sur la protection des données (nLPD) et à l'art. 27 des Statuts. Les données ne sont jamais cédées à des tiers à des fins commerciales. Pour accéder à vos données, les corriger ou les supprimer, contactez produktion@fadosamesa.ch.",
        },
    },
    faq: {
        titulo: "Questions Fréquentes",
        items: [
            { q: "Les boissons sont-elles incluses dans le billet ?", a: "Le billet comprend le porto d'honneur, les entrées, la soupe, le plat principal, le dessert et un café par personne. Boissons et digestifs en supplément." },
            { q: "Dois-je confirmer mon plat principal ?", a: "Oui. Confirmez votre présence et votre choix de plat (poisson ou viande) avant le 1er novembre 2026 sur fadosamesa.ch/confirmar." },
            { q: "Où acheter les billets ?", a: "À la billetterie officielle sur fadosamesa.ch/bilhetes (Eventim Light / Ticket Corner). L'événement est exclusif et les places sont limitées." },
            { q: "Comment rejoindre le Centro Papa Giovanni ?", a: "Hübelistrasse 55, 6020 Emmenbrücke — 10 minutes à pied de la gare d'Emmenbrücke Gersag, avec parking gratuit à proximité. Tous les détails sur fadosamesa.ch/local." },
        ],
    },
    experiencia: {
        tabs: { menu: "Menu de la Soirée", cultura: "Culture et Tradition", gastro: "Gastronomie et Vins", bar: "Bar" },
        bar: {
            nome: "A Famosa — Café & Sabores",
            cargoA: "Fonctionnement et service assurés par la",
            cargoB: "Pastelaria Famosa de Emmenbrücke",
            horarioTitulo: "Horaires d'Ouverture",
            blocos: [
                { horas: "17H00 – 18H30", estado: "Ouvert", nota: "Réception et Porto de Honra (verre de bienvenue), jusqu'au service des entrées du dîner." },
                { horas: "18H30 – 23H30", estado: "Fermé", nota: "Pendant tout l'événement." },
                { horas: "23H30 – 01H00", estado: "Rouvert", nota: "En continu jusqu'à la fermeture du lieu." },
            ],
            regra: "La règle d'exclusivité et le paiement au moment de l'achat restent en vigueur.",
        },
        tituloA: "Une soirée ",
        tituloGold: "portugaise",
        tituloB: ",",
        tituloC: "servie à table.",
        p1: "Fados à Mesa est un dîner-spectacle qui réunit le meilleur de deux patrimoines : la gastronomie portugaise et le Fado. Entre chaque plat, la guitare portugaise et la voix du fadista remplissent la salle, comme dans les maisons de fado de Lisbonne — mais ici, en Suisse.",
        p2: "Une soirée entière pensée dans les moindres détails : la table dressée, les bougies allumées, le vin servi et le silence sacré quand le fado commence.",
        menuLabel: "Menu officiel de la 1ère édition",
        menuOficial: {
            bebidasTitulo: "Les boissons sont à part.",
            bebidasTexto: "Elles ne sont pas incluses dans le prix du billet.",
            entradas: "Entrées",
            sopa: "Soupe",
            sopaValor: "Caldo Verde",
            sopaTrad: "soupe traditionnelle portugaise au chou frisé",
            prato: "Plat Principal",
            peixeLabel: "Option 1 — Poisson",
            peixeValor: "Lombo de Bacalhau Assado no Forno com Batata a Murro",
            peixeTrad: "pavé de morue rôti au four avec pommes de terre « à murro »",
            carneLabel: "Option 2 — Viande",
            carneValor: "Lombo de Porco com Batata Assada e Arroz",
            carneTrad: "longe de porc rôtie avec pommes de terre rôties et riz",
            acompanhamento: "Les deux sont accompagnés d'une salade de laitue et tomates.",
            sobremesa: "Dessert",
            sobremesaNota: "L'une de deux options au choix",
            sobremesaOpcoes: "Pudding maison · Salade de fruits",
            final: "Pour Finir",
            finalValor: "Café",
            notaBilhetes: "Les billets achetés dans la même réservation garantissent une place à la même table, dans la mesure du possible.",
            notaSilencio: "Pour préserver la magie du Fado en direct, nous vous demandons d'entrer ou de sortir de la salle uniquement pendant les intervalles.",
            notaEstacionamento: "Parking gratuit à proximité du Centro Papa Giovanni (n'appartient pas à la salle ; selon disponibilité).",
            notaRececao: "À votre arrivée, veuillez suivre les indications de notre équipe de réception.",
            fecho: "Nous espérons vous accueillir pour une soirée inoubliable, de culture portugaise, de gastronomie et de la tradition intemporelle du Fado.",
        },
        zoomHint: "Touchez le menu pour agrandir",
        importante: "Important",
        notaA: "Chaque client doit confirmer sa présence et son choix de plat principal (poisson ou viande) avant le ",
        notaB: "Chaque client doit confirmer sa présence et son choix de plat principal avant le ",
        prazoData: "1er novembre 2026",
        confirmar: "Confirmer le plat principal",
        culturaTitulo: "LA SOIRÉE, MOMENT PAR MOMENT",
        lineupTitulo: "Line Up de la Soirée",
        lineup: [
            { hora: "17h00", momento: "Arrivée des invités (jusqu'à 17h30)" },
            { hora: "17h00", momento: "Bar ouvert (jusqu'à 18h30)", link: true },
            { hora: "17h30", momento: "Porto d'Honneur" },
            { hora: "18h30", momento: "Entrées et boissons servies à table" },
            { hora: "19h00", momento: "Premier spectacle de Fado" },
            { hora: "19h30", momento: "Soupe" },
            { hora: "20h30", momento: "Deuxième moment de Fado" },
            { hora: "21h00", momento: "Plat principal" },
            { hora: "21h45", momento: "Troisième moment de Fado" },
            { hora: "22h30", momento: "Dessert et café" },
            { hora: "22h30", momento: "La cuisine ferme" },
            { hora: "23h00", momento: "Dernier fado de la soirée" },
            { hora: "23h45", momento: "Fermeture de la salle — bar uniquement, jusqu'à 01h00 (fermeture de l'espace)", link: true },
            { hora: "01h30", momento: "Fermeture du Centro Papa Giovanni" },
        ],
        lineupLink: "Voir le fonctionnement du bar",
        lineupNota: "Horaire indicatif de la 1ère édition — sujet à confirmation.",
        etiquetaTitulo: "Quand le Fado est Chanté",
        etiquetaTexto: "«Silence, on va chanter le fado.» À la portugaise : quand la guitare commence, la salle se tait — on écoute avec respect, on ressent en silence et on applaudit à la fin. C'est ainsi à Lisbonne, et ce sera ainsi à notre table.",
        bilheteTitulo: "Votre Billet Comprend",
        incluido: [
            "Porto d'honneur à l'arrivée",
            "Entrées",
            "Soupe",
            "Plat principal",
            "Dessert",
            "1 café par personne",
        ],
        bebidas: "Boissons et digestifs en supplément.",
        exclusivo: "Événement exclusif — places limitées",
        gastroTitulo: "GASTRONOMIE ET VINS",
        gastroCardTitulo: "Gastronomie Portugaise",
        gastroP1: "Nos plats naissent de produits d'origine portugaise, choisis avec le respect de celui qui cuisine pour sa famille : l'huile d'olive, la morue, la charcuterie et les douceurs qui traversent les frontières pour arriver à votre table comme on le fait au Portugal.",
        gastroP2: "Ceux qui préparent chaque plat seront présentés prochainement — notre cuisine est choisie avec le même soin que l'on accorde une guitare.",
        vinhosCardTitulo: "Vins Portugais",
        vinhosP1: "Une sélection de vins des meilleures régions du Portugal — du Douro à l'Alentejo, du Dão aux vins verts du Minho — pensée pour accompagner chaque moment du dîner et chaque fado de la soirée.",
        vinhosP2: "La carte des vins de la 1ère édition sera révélée prochainement.",
    },
    equipa: {
        titulo: "NOTRE ÉQUIPE",
        tabs: { producao: "Production", staff: "Staff" },
        producaoTitulo: "Équipe de Production",
        staffTitulo: "Staff — Cuisine, Salle et Bar",
        cozinhaTitulo: "Cuisine",
        salaTitulo: "Salle",
        barTitulo: "Bar",
        apoioTitulo: "Équipe de Cuisine et Staff",
        producao: [
            {
                id: "paula-angelino", nome: "Paula Angelino", papel: "Directrice Exécutive — Artistique et Créative",
                texto: "Responsable de la vision artistique et créative de Fados à Mesa, elle dirige l'identité du projet, la communication et la production. Son objectif est de promouvoir la culture portugaise à travers des expériences authentiques qui unissent musique, gastronomie et tradition.",
            },
            {
                id: "paula-silva", nome: "Paula Silva", papel: "Directrice Logistique et Staff",
                texto: "Responsable de l'organisation opérationnelle et de la coordination des équipes, elle veille à ce que chaque détail soit planifié avec rigueur et à ce que chaque événement se déroule avec qualité et hospitalité portugaise.",
            },
            {
                id: "paulo-nunes", nome: "Paulo Nunes", papel: "Directeur Technique et Responsable de la Sécurité des Espaces",
                texto: "Responsable de la coordination technique et de la sécurité des espaces, il garantit que chaque événement se déroule avec excellence, professionnalisme et en toute confiance.",
            },
        ],
        cozinha: [
            {
                id: "fernando-rocha", nome: "Fernando Rocha", papel: "Chef de Cuisine",
                texto: "Responsable de la création et de l'exécution des menus, il assure la qualité, l'authenticité et la présentation de chaque plat, en valorisant les meilleurs ingrédients et la tradition de la gastronomie portugaise.",
            },
            {
                id: "cristina-moita", nome: "Cristina Moita", papel: "Sous-Cheffe de Cuisine",
                texto: "Responsable du soutien à la gestion de la cuisine et de la coordination de l'équipe, elle garantit l'organisation, la rigueur et le bon fonctionnement de tous les services, contribuant à ce que chaque détail arrive à table avec excellence.",
            },
        ],
        apoio: ["Cátia Ambrai", "Paulo", "Márcia Pinheiro"],
        sala: {
            id: "sergio-rego", nome: "Sérgio Rêgo", papel: "Chef de Salle",
            texto: "Venu directement de Lisbonne, il travaille quotidiennement avec les artistes que nous présentons, assurant un service de salle attentif, discret et d'excellence, pour que chaque soirée soit une expérience inoubliable.",
        },
        salaApoio: { nome: "Rui Borges", papel: "Support de Salle" },
        barMembro: { nome: "Rui Borges", papel: "Pastelaria Famosa de Emmenbrücke" },
    },
    missao: {
        label: "La Mission",
        tituloA: "APPORTER LA ",
        tituloGold: "CULTURE PORTUGAISE",
        tituloB: " EN SUISSE",
        subtitulo: "La soirée où le Portugal invite la Suisse à s'asseoir à notre table, en hommage à une amitié construite au fil des générations entre le peuple portugais et le pays qui l'a accueilli.",
        capitulos: [
            {
                titulo: "L'Origine",
                paragrafos: [
                    "Fados à Mesa est né de la volonté de présenter le Fado dans sa forme la plus authentique, en respectant la tradition d'une expression artistique reconnue par l'UNESCO comme Patrimoine Culturel Immatériel de l'Humanité.",
                    "Plus qu'un genre musical, le Fado est une manière de préserver la mémoire, de transmettre des émotions et de raconter l'histoire d'un peuple. C'est un patrimoine vivant qui traverse les générations et continue d'unir les gens à travers la poésie, la musique et l'identité culturelle portugaise.",
                ],
            },
            {
                titulo: "Plus Qu'un Concert",
                paragrafos: [
                    "C'est pourquoi une nuit de Fado ne se vit pas comme un concert conventionnel. Elle se vit dans une ambiance intimiste, où la proximité entre artistes et public crée une expérience profondément humaine. Chaque interprétation s'écoute avec respect, chaque parole est valorisée et chaque silence fait partie de la musique.",
                ],
            },
            {
                titulo: "La Culture Mérite du Temps",
                paragrafos: [
                    "Chez Fados à Mesa, nous croyons que la culture mérite du temps. Elle mérite de l'attention. Elle mérite un espace où le patrimoine peut être vécu avec authenticité, dignité et élégance.",
                    "L'événement a été soigneusement conçu pour offrir une expérience culturelle de la plus haute qualité, où la tradition portugaise est présentée de manière contemporaine, chaleureuse et fidèle à la reconnaissance internationale que le Fado a conquise.",
                ],
            },
            {
                titulo: "Le Portugal Qui Voyage",
                paragrafos: [
                    "Quand la distance rend le retour au Portugal difficile, c'est le Portugal qui voyage jusqu'à ceux qui en ont la saudade. Fados à Mesa naît aussi de ce dessein : recréer, le temps d'une nuit, une ambiance où la mémoire, l'identité et le sentiment d'appartenance reprennent vie à travers la musique, la tradition et la culture portugaises.",
                ],
            },
            {
                titulo: "Une Invitation à la Suisse",
                paragrafos: [
                    "Mais ce projet va au-delà de la communauté portugaise. C'est aussi un geste d'amitié et de partage. C'est le Portugal qui invite la Suisse à s'asseoir à notre table. Une invitation à découvrir une culture reconnue dans le monde entier, non seulement pour la beauté de sa musique, mais aussi pour l'authenticité, l'hospitalité et la richesse de son patrimoine.",
                    "Plus qu'un dîner-spectacle, Fados à Mesa entend s'affirmer comme un lieu de rencontre entre cultures, où Portugais, Suisses et visiteurs d'horizons différents partagent la même table, écoutent les mêmes histoires et découvrent que la culture est un langage universel capable de rapprocher les gens.",
                ],
            },
        ],
        valores: [
            { n: "I", title: "Culture", text: "Apporter le Fado — patrimoine immatériel de l'humanité — à de nouveaux publics." },
            { n: "II", title: "Table", text: "Partager la gastronomie et les vins qui racontent l'histoire du Portugal." },
            { n: "III", title: "Rencontre", text: "Créer en Suisse un point de rencontre entre cultures, autour de la table." },
        ],
        fechoA: "À une époque où tant d'expériences se vivent dans la précipitation, le Fado nous invite à faire exactement le contraire : nous arrêter, écouter et ressentir.",
        fechoB: "Parce qu'il y a des moments où le plus grand signe de respect n'est pas l'applaudissement. C'est le silence.",
        fechoFinal: "Silence... le Fado va être chanté.",
    },
    contacto: {
        titulo: "CONTACTEZ-NOUS",
        intro: "Pour tout ce qui concerne Fados à Mesa, écrivez-nous ici — nous répondons avec plaisir.",
        nome: "Nom",
        nomePh: "Votre nom",
        email: "Email",
        emailPh: "votreemail@exemple.ch",
        assunto: "Sujet",
        assuntos: [
            "Réservations de groupes",
            "Partenariats et parrainages",
            "Presse et médias",
            "Questions sur la 1ère édition",
            "Autre sujet",
        ],
        mensagem: "Message",
        mensagemPh: "Écrivez votre message...",
        enviar: "Envoyer le Message",
        aEnviar: "Envoi en cours...",
        erroGenerico: "Le message n'a pas pu être envoyé. Veuillez réessayer.",
        sucessoTitulo: "Message envoyé.",
        sucessoTexto: "Merci, {nome}. Nous avons bien reçu votre message et nous répondrons bientôt.",
        fecho: "Une soirée Portugaise, sans aucun doute.",
    },
    local: {
        label: "Où se déroule l'événement",
        titulo: "COMMENT VENIR",
        intro: "Toutes les informations pratiques sur le lieu et les moyens d'arriver à Emmenbrücke — transports publics, voiture, Uber/taxi ou vélo.",
        morada: "Hübelistrasse 55, 6020 Emmenbrücke, Suisse — 47.0706° N, 8.2849° E",
        moradaCurta: "Hübelistrasse 55, 6020 Emmenbrücke",
        comoChegar: "COMMENT ARRIVER",
        cards: [
            {
                id: "transportes",
                title: "En Transports Publics",
                text: "La gare d'Emmenbrücke Gersag se trouve à environ 10 minutes à pied et est desservie par des trains régionaux et les bus 41, 42, 43 et 44. Depuis Lucerne, la ligne 2 des VBL relie le centre d'Emmenbrücke ; au retour, le bus de nuit N2 dessert Lucerne.",
            },
            {
                id: "carro",
                title: "En Voiture",
                text: "À 5 minutes de l'autoroute A2 (sortie Emmen Nord). Parking Häger gratuit juste en face, limité aux places signalées « Häger » — tous les détails ci-dessous.",
            },
            {
                id: "uber",
                title: "En Uber ou Taxi",
                text: "Uber opère à Lucerne et ses environs : une course depuis le centre de Lucerne prend environ 10 minutes.",
            },
            {
                id: "bicicleta",
                title: "À Vélo",
                text: "Emmen n'est qu'à quelques minutes à vélo de Lucerne, par des pistes cyclables. Un parking à vélos est disponible sur place.",
            },
        ],
        mapsCta: "Ouvrir dans Google Maps",
        mapsTexto: "Pointez l'appareil photo vers le code ou touchez ici — la localisation exacte et les parkings les plus proches sont à un toucher de distance.",
        barTitulo: "Bar sur Place",
        barTexto: "Ouvert de 17h00 à 18h30 et de 23h30 à 01h00. Service assuré par la Pastelaria Famosa de Emmenbrücke — paiement au moment de l'achat.",
        estacionamentoHager: {
            titulo: "Parking Gratuit — Häger",
            intro: "Le parking le plus proche de l'événement est celui de Häger, juste en face du Centro Papa Giovanni — gratuit, mais limité à la capacité du site.",
            pontos: [
                "Seules les places signalées « Häger » sont mises à disposition des clients de l'événement.",
                "Cette information est fournie à titre purement indicatif : nous ne sommes pas responsables de l'occupation du parking. Il n'est pas nécessaire de payer.",
                "Si le parking est complet, cherchez dans les environs immédiats — plusieurs autres parkings sont disponibles, certains gratuits et d'autres payants.",
            ],
            mapsCta: "Voir le parking sur Google Maps",
        },
        fecho: "Arriver est facile. Le difficile sera de repartir.",
    },
    noticias: {
        label: "Salle de presse",
        titulo: "ACTUALITÉS",
        intro: "Bienvenue sur la page d'actualités officielle de Fados à Mesa. Vous y trouverez les dernières annonces officielles de Fados à Mesa ainsi qu'une sélection d'articles consacrés aux artistes participant à notre événement. Notre objectif : vous tenir informé par des sources fiables et officielles, tout en mettant en lumière les artistes qui rendent ce projet possible. Cette page est mise à jour régulièrement dès que de nouvelles informations officielles sont disponibles.",
        socialTitulo: "NOTRE DERNIÈRE PUBLICATION",
        socialTituloMulti: "NOS DERNIÈRES PUBLICATIONS",
        socialVer: "Voir la publication",
        socialSeguir: "Suivez-nous",
        socialBio: "Fados à Mesa est arrivé sur Instagram — suivez-nous pour les annonces officielles, les artistes et les coulisses de la soirée.",
        verTodas: "Voir toutes les actualités",
        ultimasTitulo: "DERNIÈRES ACTUALITÉS",
        filtros: { todas: "Tous", projeto: "Fados à Mesa" },
        pesquisaPh: "Rechercher par mot-clé...",
        lerMais: "Lire la suite",
        carregarMais: "Charger plus",
        aCarregar: "Chargement...",
        semResultados: "Aucune actualité trouvée. Essayez un autre artiste ou un autre mot-clé.",
        fonte: "Source",
        ctaTitulo: "Vivez le Fado en Direct",
        ctaReservar: "Réservez Votre Place",
    },
    patrocinadoresPage: {
        titulo: "SPONSORS OFFICIELS",
        texto: "Les partenaires qui rendent cette soirée possible — merci de croire en la culture portugaise en Suisse.",
    },
    confirmacao: {
        label: "1ère Édition · 14 novembre 2026",
        titulo: "CONFIRMEZ VOTRE PRÉSENCE",
        introA: "Confirmez votre présence et choisissez votre plat principal avant le ",
        prazoData: "1er novembre 2026",
        nome: "Nom complet",
        nomePh: "Votre nom",
        email: "Email",
        emailPh: "votreemail@exemple.ch",
        bilhete: "Numéro du billet (Ticket Corner)",
        bilhetePh: "Ex. : TC-123456789",
        escolhePrato: "Choisissez le plat principal",
        opcoes: [
            { id: "peixe", title: "Option 1 — Poisson", desc: "Pavé de morue rôtie avec pommes de terre à murro et salade" },
            { id: "carne", title: "Option 2 — Viande", desc: "Filet de porc rôti avec pommes de terre à murro et salade" },
        ],
        submit: "Confirmer ma Présence",
        aRegistar: "Enregistrement...",
        erroGenerico: "La confirmation n'a pas pu être enregistrée. Veuillez réessayer.",
        sucessoTitulo: "Présence confirmée.",
        sucessoTexto: "Merci, {nome}. Votre choix ({prato}) a été enregistré. À bientôt — le 14 novembre, à table.",
        peixe: "poisson",
        carne: "viande",
    },
    vantagens: {
        label: "Membres",
        titulo: "AVANTAGES ET PARTENARIATS MEMBRES",
        intro: "Être membre de Fados à Mesa coûte CHF 2 par mois (CHF 24 par an) et donne accès à des réductions dans plusieurs lieux, au Portugal et en Suisse — dès la 1re édition.",
        prova: "Pour bénéficier des partenariats, il suffit de présenter votre Carte de Membre Digitale (avec QR code) ou d'indiquer votre numéro de membre.",
        bilhetesTitulo: "Billets de la 1re Édition — 14 novembre 2026",
        bilhetesIntro: "Réduction immédiate à l'achat de billets physiques à la Pastelaria Famosa, Emmenbrücke (espèces, Twint ou virement).",
        colBilhete: "Billet",
        colAte: "Jusqu'au 31.10.2026",
        colDepois: "Dès le 01.11.2026",
        linhas: [
            ["Adulte, prix normal", "CHF 119.90", "CHF 129.90"],
            ["Membre, 1er billet adulte (− CHF 20)", "CHF 99.90", "CHF 109.90"],
            ["Adulte acheté avec un membre (− CHF 10)", "CHF 109.90", "CHF 119.90"],
            ["Enfant (6–15 ans)", "CHF 65.00", "CHF 65.00"],
            ["Enfant acheté avec un membre (− CHF 5)", "CHF 60.00", "CHF 60.00"],
        ],
        bilhetesNota: "Les réductions membres s'appliquent uniquement aux billets achetés avec le membre, dans la même transaction. Le numéro de membre doit figurer sur tous les billets, pour l'enregistrement interne.",
        fisicoTitulo: "Pourquoi uniquement des billets physiques ?",
        fisicoTexto: "Pour des raisons de gestion de projet, lors de cette 1re édition les billets à tarif membre ne sont disponibles que physiquement, à la Pastelaria Famosa. Nous comptons résoudre cette situation lors d'une prochaine édition et étendre la réduction à l'achat en ligne.",
        protocolosTitulo: "Accords avec les Partenaires",
        srVinhoTitulo: "Sr. Vinho — Restaurant Typique",
        srVinhoTag: "Partenaire Officiel",
        srVinhoTexto: "Tous les membres de Fados à Mesa bénéficient dès maintenant de 10% de réduction en cas de paiement en espèces sur le montant final du dîner au restaurant Sr. Vinho, ainsi que d'un digestif offert.",
        srVinhoCta: "Voir le menu du Sr. Vinho",
        famosaTitulo: "Pastelaria Famosa — Emmenbrücke",
        famosaTag: "Sponsor Exclusif",
        famosaTexto: "Point de vente officiel des billets physiques à tarif membre pour la 1re édition. Paiement en espèces, Twint ou virement bancaire.",
        cr7Titulo: "CR7 Helder — Transport en Limousine",
        cr7Tag: "Sponsor Premium Officiel",
        cr7Texto: "Avec le code CR7, les membres bénéficient de 10% de réduction sur toutes les limousines Vachoux (Helder Pacheco). Offre limitée au territoire de la Ville de Genève, pour des trajets de 45 minutes, avec des limousines de 12 à 16 personnes maximum.",
        cr7Codigo: "Code : CR7",
        cr7Cta: "Réserver sur vachoux.com",
        emBreve: "D'autres partenariats arrivent bientôt au Portugal et en Suisse. Les membres seront informés par e-mail.",
        ctaTitulo: "Pas encore membre ?",
        ctaTexto: "Adhésion simple, en ligne, pour CHF 24/an.",
        cta: "Devenir membre",
    },
    bilhetes: {
        precosTitulo: "Prix des Billets",
        precosStandard: "Standard",
        precosEarlyBird: "Early Bird",
        precosNormal: "Prix Normal",
        precosCrianca: "Enfant (6–15 ans)",
        precosCriancaNota: "Dîner avec eau et un jus maison offert · Porto de Honra non inclus",
        socioLink: "Membres : CHF 20 de réduction sur le 1er billet — voir les avantages",
        precosNota: "Boissons non comprises · Places limitées · Dress code : tenue de dîner élégante (pas un gala, mais presque)",
        titulo: "BILLETTERIE",
        data: "14 novembre 2026 · Centro Papa Giovanni, Emmenbrücke",
        exclusivo: "Événement exclusif · Places limitées",
        confirmarReserva: "Confirmer la Réservation",
        nota: "Billetterie officielle Eventim. Après votre achat, confirmez votre présence et votre choix de plat sur ",
    },
    ticketcorner: { label: "PARTENAIRE OFFICIEL DE VENTE" },
    privacidade: {
        label: "Fados à Mesa",
        titulo: "POLITIQUE DE CONFIDENTIALITÉ",
        seccoes: [
            {
                title: "1. Responsable du traitement des données",
                text: "Le responsable du traitement des données personnelles sur ce site est l'Association Fados à Mesa (ci-après «nous»), UID CHE-306.330.271, Gerliswilstrasse 46, 6020 Emmenbrücke, Suisse. Pour toute question relative à la protection des données, contactez-nous via la page Contact.",
            },
            {
                title: "2. Cadre légal",
                text: "Le traitement des données personnelles est effectué conformément à la Loi fédérale suisse sur la protection des données (nLPD, en vigueur depuis le 1er septembre 2023) et à la législation suisse applicable.",
            },
            {
                title: "3. Données que nous collectons",
                text: "À ce stade, le site ne collecte pas de données personnelles via des formulaires. Lorsque vous nous contactez par email, nous traitons votre adresse et le contenu du message uniquement pour répondre à votre demande. Les données de réservation ou d'achat de billets seront traitées à l'avenir via la plateforme Ticket Corner, selon la politique de confidentialité de cette plateforme.",
            },
            {
                title: "4. Cookies et outils d'analyse",
                text: "Ce site n'utilise actuellement ni cookies de suivi ni outils d'analyse de tiers. S'ils venaient à être introduits, cette politique sera mise à jour en conséquence.",
            },
            {
                title: "5. Vos droits",
                text: "Conformément à la législation suisse, vous avez le droit de demander des informations sur vos données personnelles, ainsi que leur rectification ou suppression. Pour exercer ces droits, contactez-nous via la page Contact.",
            },
            {
                title: "6. Modifications",
                text: "Nous nous réservons le droit de mettre à jour cette politique à tout moment. La version en vigueur est celle publiée sur cette page. Dernière mise à jour : septembre 2026.",
            },
        ],
    },
    termos: {
        label: "Fados à Mesa",
        titulo: "CONDITIONS GÉNÉRALES",
        seccoes: [
            {
                title: "1. Objet",
                text: "Les présents Termes & Conditions régissent l'utilisation du site Fados à Mesa et la participation à l'événement. En utilisant ce site, vous acceptez intégralement ces conditions.",
            },
            {
                title: "2. Propriété intellectuelle",
                text: "Le concept, la dénomination «Fados à Mesa», le logotype, les textes, les photographies, les vidéos, le design et tous les contenus de ce site sont la propriété exclusive de l'organisation de l'événement et sont protégés par la Loi fédérale suisse sur le droit d'auteur et les droits voisins (LDA) et par les conventions internationales applicables. La reproduction, la copie, l'imitation, la distribution ou l'utilisation, totale ou partielle, du concept, de la marque, des textes, des images ou de tout élément distinctif du projet est expressément interdite sans autorisation préalable et écrite de l'organisation. Toute violation fera l'objet d'une action en justice selon la législation suisse.",
            },
            {
                title: "3. Billets et réservations",
                text: "La vente des billets sera effectuée via la plateforme Ticket Corner, dont les termes et conditions s'appliquent. L'événement a une capacité limitée ; la réservation n'est valable qu'après confirmation du paiement.",
            },
            {
                title: "4. Programme et modifications",
                text: "L'organisation se réserve le droit d'ajuster le programme, les horaires, le menu et la distribution pour des raisons de force majeure, en garantissant toujours la qualité de l'expérience annoncée.",
            },
            {
                title: "5. Responsabilité",
                text: "L'organisation n'est pas responsable des dommages résultant d'informations de tiers, de défaillances techniques étrangères ou d'une utilisation inappropriée du site. La consommation de boissons alcoolisées est réservée aux personnes majeures, conformément à la législation suisse.",
            },
            {
                title: "6. Droit applicable et for",
                text: "Les présentes Conditions sont régies par le droit suisse. Pour tout litige, le for du domicile de l'organisation, en Suisse, est compétent. Dernière mise à jour : septembre 2026.",
            },
        ],
    },
    artistPage: {
        naoEncontrado: "Artiste non trouvé.",
        imprensa: "Presse & Distinctions",
        emPalco: "Sur scène",
        oQueA: "Ce qui vous ",
        oQueGold: "attend",
        oQueB: "",
    },
    artists: {
        "rafael-pacheco": {
            role: "Guitare Portugaise",
            bio: "Né à Portimão (2000), il a commencé à 11 ans à l'école de fado Boa Esperança et s'est formé auprès du prestigieux guitariste de guitare portugaise Antunes, le Prince.\n\nLauréat du Prix Nouveaux Talents Ageas, à la Casa da Música (2023), il est musicien résident dans des maisons de fado emblématiques, de Viseu à Lisbonne.",
        },
        "ginestal-martins": {
            role: "Viola de Fado",
            bio: "Violiste de fado du circuit lisboète, il est le socle musical d'innombrables soirées — la viola qui soutient, avec sensibilité, chaque voix.\n\nIl accompagne des fadistas dans les maisons de fado et lors des Visitas Cantadas de l'EGEAC, à travers les quartiers historiques de Lisbonne, aux côtés de guitaristes comme Rafael Pacheco. Il se produit également comme fadista.",
        },
        "catia-garcia": {
            role: "Fadista",
            bio: "Fadista d'âme et de tradition, elle porte sur scène l'émotion de celles et ceux qui vivent le fado de l'intérieur. En 2021, elle a publié l'album «À Procura do Fado».\n\nPrésence régulière à la télévision (RTP) et dans les soirées fado de Lisbonne, y compris l'emblématique maison Sr. Vinho.",
        },
        "daniel-pinto-coelho": {
            role: "Fadista",
            bio: "Né à Valongo, il est monté sur scène pour la première fois à 4 ans et a étudié à la London Music School, avant de se laisser conquérir par le fado en 2014.\n\nIl fait partie de la distribution de l'emblématique maison de fado Sr. Vinho, à Lisbonne, où sa voix élégante est une présence habituelle.",
        },
        "madalena-gil": {
            role: "Fadista",
            bio: "Née à Almeirim, elle a charmé le pays dans The Voice Kids Portugal, en 2021, avec le fado «Ser Fadista».\n\nUne voix jeune à l'âme ancienne, qui promet de porter le fado — et le nom du Portugal — encore plus loin.",
        },
    },
};
